
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

import {Api} from '@/api/config'

import Cookies from 'js-cookie'

import env from '@/env'

const check_lock_expire = 3000
let memory_check_lock = 0
let loop_sync_login_interval = 2000 //每隔多久同步一次登录状态

if(process.env.NODE_ENV !== 'production'){
  loop_sync_login_interval = 120000 //开发环境减少同步频率, 2分钟一次
}

const loop_check_login_interval = 300000 //每隔多久验证一次登录用户信息, 5分钟
const loop_check_login_lock_name = "lock.check_login"
const lock_ttl = 5000

const state = {
  status: '',
  judge_token: '',
}

const getters = {
  is_login: (state) => {
    return state.judge_token
  }
}

const mutations = {

  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, data) {

    Cookies.set('judge_token', data.token)
    mutations.sync_local_storage(state)

    state.status = 'success'
  },
  auth_error(state) {

    // mutations.logout(state) //接口出错不再退登

    state.status = 'error'
  },
  logout(state) {

    Cookies.set('judge_token', '')
    mutations.sync_local_storage(state)
    state.status = ''
  },
  sync_local_storage(state){

    let newToken = Cookies.get('judge_token') || ''

    if(state.judge_token != newToken){
      state.judge_token = newToken
    }
  },
  sync_login(state){

    mutations.sync_local_storage(state)

    var app = env.app
    if(!app){
      return
    }

    //如果处于退登状态，跳转到登录页
    if(!state.judge_token){

      const login_path = "/judge/login"

      let judgeLogin = app.$route.matched.some(record => record.meta.judgeLogin)
      if(!judgeLogin){
        return
      }

      app.$router.replace({
        path: login_path,
        query: {to_url: app.$route.fullPath}
      })

      return
    }
  }
}

mutations.sync_local_storage(state)

const actions = {
  async login({commit, state, dispatch}, params) {
    return new Promise((resolve, reject) => {

      commit('auth_request')

      let loginApi = Api.judge_login
      let pass = params.password
      let loginParams = new FormData()
      loginParams.append('pass', pass)

      axios.post(loginApi, loginParams).then(response => {

        let respData = response.data

        if(respData.code != 200){
          let msg = "登录失败, 密钥错误！"
          resolve({
            success: false,
            msg: msg
          })
          return
        }

        let token = respData.data.access_token
        Cookies.set('judge_token', token)

        commit('sync_local_storage')

        dispatch('check_login').then(isSuccess => {
          if(!isSuccess){
            return
          }

          resolve({
            success: true
          })
        })

      }).catch((error) => {

        commit("auth_error")

        throw(error)
      })
    })
  },
  logout({commit, state}) {
    return new Promise((resolve, reject) => {
      Cookies.remove('judge_token')
      commit('logout')
      resolve({
        success: true
      })
    })
  },
  check_login({commit, state}) {


    return new Promise((resolve, reject) => {

      if(!state.judge_token){

        commit("logout")

        resolve(false)
        return
      }

      let thisTime = new Date().getTime()
      let lockTime = memory_check_lock
      let lockPass = !(lockTime > 0) || thisTime < lockTime || thisTime - lockTime > check_lock_expire

      if(!lockPass){
        return
      }

      memory_check_lock = thisTime

      let userInfoApi = Api.judge_check_login

      let params = new FormData()
      params.append('access_token', state.judge_token)

      axios.post(userInfoApi, params).then((response) => {

        var respData = response.data

        if(respData.code == 200){

          commit('auth_success', {
            token: state.judge_token
          })

          resolve(true)
        }else{

          commit('logout')

          resolve(false)
        }

        memory_check_lock = 0
      }).catch((error) => {

        commit("auth_error")

        throw(error)
      })
    })
  },
  loop_sync_login({commit, state, dispatch}) {
    window.setInterval(function(){

      commit("sync_login")

    }, loop_sync_login_interval)
  },
  loop_check_login({commit, state, dispatch}) {

    //定期循环验证登录状态
    window.setInterval(function(){

      if(state.status == "loading"){
        return
      }

      commit("sync_login")

      let thisTime = new Date().getTime()
      let lockTime = parseInt(Cookies.get(loop_check_login_lock_name))
      let lockPass = !(lockTime > 0) || thisTime < lockTime || thisTime - lockTime > lock_ttl

      if(!lockPass){
        return
      }

      Cookies.set(loop_check_login_lock_name, thisTime)

      dispatch('check_login')

    }, loop_check_login_interval)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth_judge.js